import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

export const OnGoingRequestList = () => {
  
  return (
    <>
  {/* Page Wrapper */}
  <div id="wrapper">
    {/* Sidebar */}
   <Sidebar/>
    {/* End of Sidebar */}
    {/* Content Wrapper */}
    <div id="content-wrapper" className="d-flex flex-column">
      {/* Main Content */}
      <div id="content">
        {/* Topbar */}
       <Header/>
        {/* End of Topbar */}
        {/* Begin Page Content */}
        <div className="container-fluid">
  <div className="card shadow mb-4">
    <div className="card-header py-3">
      <h6 className="m-0 font-weight-bold text-primary">On Going Requests</h6>
    </div>
    <div className="card-body">
      <div className="table-responsive">
        <table
          className="table table-bordered"
          id="dataTable"
          width="100%"
          cellSpacing={0}
        >
          <thead>
            <tr>
              <th>Number</th>
              <th>Customer Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>ram patil</td>
              <td>
                <button className="btn btn-primary">update</button>
                <button className="btn btn-danger">delete</button>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>prathmesh patil</td>
              <td>
                <button className="btn btn-primary">update</button>
                <button className="btn btn-danger">delete</button>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>ramesh patil</td>
              <td>
                <button className="btn btn-primary">update</button>
                <button className="btn btn-danger">delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>





        {/* /.container-fluid */}
      </div>
      {/* End of Main Content */}
      {/* Footer */}
     <Footer/>
      {/* End of Footer */}
    </div>
    {/* End of Content Wrapper */}
  </div>
  {/* End of Page Wrapper */}
  {/* Scroll to Top Button*/}
  
</>

  );
};
